import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {CodeComponent} from './pages/code/code.component';


const routes: Routes = [
  {path: '', redirectTo: '/code', pathMatch: 'full'},
  {path: 'code', component: CodeComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
